import * as types from "../actions/types";

const INITIAL_STATE = {
  dashboard_data: null,
  dashboard_data_loading: false,
  last_refreshed: null
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.TOGGLE_DASHBOARD_DATA_LOADING:
        return {
          ...state,
          dashboard_data_loading: !state.dashboard_data_loading
        };
    case types.FETCH_ALL_DASHBOARD_DATA:
      return {
        ...state,
        dashboard_data: action.payload,
        dashboard_data_loading: false,
        last_refreshed: new Date().toLocaleString("en-US", {
          timeZone: "America/New_York"
        })
      };

    default:
      return state;
  }
}
